<cdk-virtual-scroll-viewport [itemSize]="itemHeight" inViewport forceResize class="infinite-scroll__viewport">
    <div class="infinite-scroll__viewport-row">
        <ng-container *cdkVirtualFor="let row of ds; let rowId = index; trackBy: trackByFn;">
            <div *ngFor="let item of row; let colId = index;" class="infinite-scroll__viewport-item" [ngStyle]="{ 'height': itemHeight + 'px' }" id="infiniteScrollElement-{{colId}}-{{rowId}}">
                <ng-container *ngTemplateOutlet="template, context: { item: item, index: rowId * itemsPerRow + colId }"></ng-container>
            </div>
        </ng-container>
    </div>
</cdk-virtual-scroll-viewport>